<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion diseño-validado">DISEÑOS ANALÓGICOS VALIDADOS</div>
